<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search_tab_one') ||
                  '盘点单号/库位编号/盘点人/成品工厂 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="130px"
        size="small"
        class="mt-3"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amz_fty_check_no') || '盘点单号'"
            >
              <el-input
                v-model.trim="form.amzFtyCheckNo"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_location_no') || '库位编号'">
              <el-input v-model.trim="form.locationNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_checked_by') || '盘点人'">
              <dict-select
                v-model="form.createBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_factory') || '成品工厂'"
            >
              <dict-select
                v-model="form.scmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_inventory_date') || '盘点日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_bill_in_date') || '入库日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginInboundDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endInboundDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
